module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_10000_25000.611f13f4.png";